import { useSelector } from "../store";

export default function useRoles() {
  return useSelector((state) => state.user.roles);
}
